//Layout.tsx
import { Outlet, Link, useLocation } from "react-router-dom";
import Banner from "./Banner";
import Footer from "./Footer/Footer";
import hamburgerDark from "../images/hamburger-dark.svg";
import searchImg from "../images/search.svg";
import cross from "../images/cross.svg";
import LiftsLogoDark from "../images/logos/OwnPathCareDirectory-acai.svg";
import LiftsLogoLight from "../images/logos/OwnPathCareDirectory-white.svg";
import SpanishOpcdLogoLight from "../images/logos/OwnPathCareDirectory-spanish-bw.svg";
import SpanishOpcdLogoDark from "../images/logos/spanish_logo_solid_blue.svg";

import styled from "styled-components";
import { useTranslation } from "react-i18next";
import AlertBanner from "./AlertBanner";
import { isMobile } from "react-device-detect";
import { useState } from "react";
import SearchAutocomplete from "./ProviderSearch/SearchAutocomplete";
import ContactUs from "./ContactUs";

const Wrapper = styled.div`
  min-height: 100%;
  width: 100%;
`;

const ResponsiveHeader = styled.div`
  display: flex;
  justify-content: space-between;
  @media print
  {    
    display: none !important;
  }
`;

const TextLink = styled.a`
  text-decoration: none;
  padding: 5px;
  margin: 0px 20px;
  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
`;


type LayoutProps = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
};

function Layout({ isOpen, setIsOpen }: LayoutProps) {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false); // this is used to close the dialog after the selection.
  const logoEn = (isMobile && (menuOpen || searchOpen)) || !isMobile && location.pathname === '/' ? LiftsLogoLight : LiftsLogoDark;
  const logoEs = (isMobile && (menuOpen || searchOpen)) || !isMobile && location.pathname === '/' ? SpanishOpcdLogoLight : SpanishOpcdLogoDark;

  return (
    <Wrapper as="div" className={location.pathname === '/' ? "homeHeader" : ""} role="img" aria-label="bg-img">
      <div>
        <AlertBanner Message={t("providerNotificationBanner")} Visible={false}></AlertBanner>{/* TODO: make visibility (and message?) configurable */}
        <Banner />
        <ResponsiveHeader as='div' >
          <div className="headerLogo">
            <Link to="/" title="Home" aria-label="Home">
              <img
              src={i18n.language === "es" ? logoEs : logoEn }
              height={56}
              width="auto"
              alt={t("liftsLogoAlt")}
              onClick={() => setMenuOpen(false)}
              />
            </Link>
          </div>
          {!isMobile ?
          <div className="display-flex flex-align-center flex-justify-center padding-x-10">
            <TextLink as='a' href="/about" className={location.pathname === '/' ? "black nice_font" : "dark_blue nice_font"}>{t("about")}</TextLink>
            <TextLink as='a' onClick={() => setIsOpen(true)} className={location.pathname === '/' ? "black nice_font" : "dark_blue nice_font"}>{t("contact")}</TextLink>
            <TextLink as='a' href={t("complaintFormUrl")} target="blank" className={location.pathname === '/' ? "black nice_font" : "dark_blue nice_font"}>{t("provideFeedback")}</TextLink>
            <SearchAutocomplete closeSearchDlg={() => setSearchOpen(false)} darkBackground={ false }/>
          </div>
          :
          <div className="mobileDropdown display-flex flex-align-center flex-justify-center">
            <img src={searchImg} alt="menu" onClick={() => setSearchOpen(true)} style={{marginRight: "20px"}} />
            <img src={hamburgerDark} alt="menu" onClick={() => setMenuOpen(true)} />
          </div>
          }
        </ResponsiveHeader>
      </div>
      <div className={location.pathname === '/about' || location.pathname === '/faq' ? "purpleBackground" : ""} style={{"flexGrow":"1"}}>
        <Outlet />
      </div>
      <div>
      <Footer />
      </div>
      
      {menuOpen && 
      <div className="mobileMenu">
        <img src={cross} alt="close" onClick={() => setMenuOpen(false)} />
        <hr></hr>
        <div className="columns">
          <TextLink as='a' href="/about" className="white nice_font">{t("about")}</TextLink>
          <TextLink as='a' onClick={() => setIsOpen(true)} className="white nice_font">{t("contact")}</TextLink>
          <TextLink as='a' href={t("complaintFormUrl")} target="blank" className="white nice_font">{t("provideFeedback")}</TextLink>
        </div>
      </div>}

      {searchOpen && 
      <div className="mobileMenu">
        <img src={cross} alt="close" onClick={() => setSearchOpen(false)} />
        <hr></hr>
        <div className=" display-flex flex-align-center flex-justify-center">
          <SearchAutocomplete closeSearchDlg={() => setSearchOpen(false)} darkBackground={false} />
        </div>
      </div>}

      {isOpen &&
      <ContactUs isMobile={isMobile} isOpen={isOpen} toggle={() => setIsOpen(!isOpen)} ></ContactUs>
      }
    </Wrapper>
  );
}

export default Layout;
